import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const autista: AnaColumn[] = [

  {
    configuration:
    {
      titleGriglia: 'descrizioneSoggetto - $descrizioneSede',
      titleForm: 'descrizioneSoggetto - $descrizioneSede',
      breadcrumbCaption: 'Anagrafica autisti',
      allowedAdvancedFilter: false,
      isAdvancedXlsExportAvailable: false,
      campoTitle: ['descrizioneSede', 'descrizioneSoggetto', 'nome', 'cognome'],
      startTemplate: 'grid',
      service: 'autista',
      api: 'autista',
      filterList: '/$idSede',
      filterEditor: '?id=$',
      helpDoc: 'Autisti.html',
      idTabRif: [
        {
          key: 'idSede',
          value: 'idSede'
        },

      ],
      queryFilter: [

      ],
      formType: 'simple',
      masterKey: 'id',
      nCol: 1,
      toolbarSettings: {
        service: 'autista',


      }





    }

  },

  {
    itemType: "group", groupWidth: 850, colCount: "2", caption: 'Dati Autista', data: [


      


      {
        showInColumnChooser: false,
        type: 'campo',
        maxLength: "25",
        dataField: "nome",
        caption: "Nome",
        colSpan:2,
        nCol: 5,
        validation: [{
          type: 'required', message: 'Campo obbligatorio'
        }]
      },
      {
        showInColumnChooser: true,
        allowHiding: false,
        type: 'campo',
        dataField: "cognome",
        caption: "Cognome",
        maxLength: "25",
        nCol: 5,
        colSpan:2,
        validation: [{
          type: 'required', message: 'Campo obbligatorio'
        }]
      },

     

      {
        showInColumnChooser: true, allowHiding: false,
        type: 'campo', colVisible: true,
        dataField: "matricola",
        caption: 'Matricola',
        dataType: "",
        colSpan:2,
        maxLength: "25",
        nCol: 4,   
      },
      {
        type: 'campo', 
        dataField: "telefono", 
        dataType: "telefono",
        caption: 'Telefono', 
        maxLength: "15",
        editorType: 'dxTextBox', 
        showInColumnChooser: true, 
        allowHiding: false,

        colSpan:2,
        nCol: 4,       
      },
     

      {
        type: 'campo',  
        colSpan:2,
        nCol: 5,       
        dataField: "email", 
        dataType: "",
        caption: 'Email',
        maxLength: "40", 
        showInColumnChooser: true,
        allowHiding: false,
      },

      {
        type: 'campoData', dataType: 'date', dataField: 'dataAssunzione', caption: 'Data Inizio', 
        colVisible: true,  format: "dd/MM/yyyy", editorType: "dxDateBox",nCol:25
      },
      {
        type: 'campoData', dataType: 'date', dataField: 'dataFineAssunzione', caption: 'Data Fine',
        colVisible: true, format: "dd/MM/yyyy", editorType: "dxDateBox", nCol:25, labelWidth:90
      },

      {
        showInColumnChooser: true,
        allowHiding: false,
        type: 'campo',
        colSpan:2,
        dataField: 'isAutista',
        dataType: "boolean",
        editorType: 'dxCheckBox',
        showEditorAlways: false,
        caption: 'Autista',
        hideOnEdit: false,
        falseText: 'No',
        trueText: 'Si'

      },

      {
        showInColumnChooser: true,
        allowHiding: false,
        type: 'campo',
        colSpan:2,
        dataField: 'isOperaio',
        dataType: "boolean",
        editorType: 'dxCheckBox',
        showEditorAlways: false,
        caption: 'Operaio',
        hideOnEdit: false,
        falseText: 'No',
        trueText: 'Si'
      },

      {
        showInColumnChooser: true, allowHiding: false, 
        type: 'campo',
        dataField: 'isAutorizzatoADR',
        caption: 'Aut. ADR',
        dataType: "boolean", 
        editorType: 'dxCheckBox',
        showEditorAlways: false,
        hideOnEdit: false,
        falseText: 'No', 
        trueText: 'Si', 
        colSpan:2,
        nCol: 10,
      },

      
    ]
  },
]